const L = {
  name: "SaoJoseDosCampos",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.9999 2C11.2081 2 10.4512 2.28119 9.8811 2.78761C9.30209 3.28719 8.90618 3.98708 8.79775 4.78229L2 11.58V14.42L8.4414 7.97864L8.17117 10.4089L2 16.58V19.42L7.81588 13.6041L7.10471 20H2V22H22V20H16.8955L16.186 13.6058L22.0002 19.42V16.58L15.8316 10.4114L15.5618 7.982L21.9998 14.42V11.58L15.2028 4.783C15.1598 4.46183 15.0603 4.17154 14.9408 3.91702C14.4409 2.77468 13.298 2 11.9999 2ZM11.2067 4.28524C11.3956 4.11617 11.6754 4 11.9999 4C12.4951 4 12.9271 4.29732 13.1113 4.72532L13.1188 4.74278L13.127 4.75993C13.189 4.89014 13.2164 4.99326 13.2236 5.07663L13.2248 5.08943L14.8823 20H9.11743L10.7736 5.1022L10.7746 5.0929C10.8075 4.77504 10.9594 4.49748 11.1907 4.29926L11.1987 4.29233L11.2067 4.28524Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as SaoJoseDosCampos
};
